import React, { useEffect } from 'react'
import { toast } from 'react-hot-toast'
import { Anomaly } from '../../types/anomaly'
import { useAnomalySocket } from '../../hooks/useAnomalySocket'

const AnomalyNotification: React.FC = () => {
  const { anomalies, isConnected } = useAnomalySocket()

  useEffect(() => {
    // Show toast notification for new critical anomalies
    const latestAnomaly = anomalies[0]
    if (latestAnomaly && latestAnomaly.severity === 'critical') {
      toast.error(
        `Critical anomaly detected in ${latestAnomaly.system_id}: ${latestAnomaly.metric} = ${latestAnomaly.value.toFixed(2)}`,
        {
          duration: 8000,
          icon: '🚨',
        }
      )
    } else if (latestAnomaly && latestAnomaly.severity === 'warning') {
      toast(
        `Warning: Anomaly in ${latestAnomaly.system_id}: ${latestAnomaly.metric} = ${latestAnomaly.value.toFixed(2)}`,
        {
          duration: 5000,
          icon: '⚠️',
          style: {
            background: '#f59e0b',
            color: '#fff',
          },
        }
      )
    }
  }, [anomalies])

  // Connection status indicator - disabled until WebSocket is properly configured
  // useEffect(() => {
  //   if (!isConnected) {
  //     toast.error('Anomaly detection system disconnected', {
  //       id: 'anomaly-connection',
  //       duration: Infinity,
  //     })
  //   } else {
  //     toast.dismiss('anomaly-connection')
  //   }
  // }, [isConnected])

  return null // This component only handles notifications
}

export default AnomalyNotification